import {
  createStyles,
  ListItem,
  Theme,
  WithStyles,
  withStyles
} from '@material-ui/core';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import classnames from 'classnames';
import moment from 'moment';
import React from 'react';
import MyButton from '../../components/UI/MyButton/MyButton';
import MyTable from '../../components/UI/MyTable/MyTable';
import { IFeed, IPlayoutScreen } from '../../models/states';
const styles = (theme: Theme) =>
  createStyles({
    root: {},
    blur: {
      filter: 'blur(2px)'
    },
    actionButtons: {
      marginRight: '1rem'
    }
  });

class PlayoutStreamSummary extends React.Component<
  IPlayoutStreamSummaryOwnProps
> {
  renderGridItem = (label: string, value: any, blur: boolean = false) => {
    return (
      <ListItem>
        <Grid item xs={3}>
          <Typography>{label}</Typography>
        </Grid>
        <Grid item xs={9}>
          <Typography
            className={classnames({ [this.props.classes.blur]: blur })}
          >
            {value}
          </Typography>
        </Grid>
      </ListItem>
    );
  };
  renderTable = (title: string, rows: any, header: any) => {
    return (
      <React.Fragment>
        <ListItem>
          <Grid item xs={12}>
            <Typography>{title}</Typography>
          </Grid>
        </ListItem>

        <ListItem style={{ marginTop: '-2rem' }}>
          <Grid item xs={12}>
            <MyTable
              tRows={rows}
              tHead={header}
              order="asc"
              orderBy={''}
              multiSelect={false}
            />
          </Grid>
        </ListItem>
      </React.Fragment>
    );
  };
  public render() {
    const { playoutFeed } = this.props;
    let errorRows = [];
    const warningRows = [];
    const blur = globalThis.UI_CONFIG.blur_data;
    const multiFeedViewUrl = playoutFeed
      ? `https://${playoutFeed.customer}/nexus?component=multi_channel_view&component_path=${playoutFeed.feed_code}`
      : '';
    const header = [
      {
        label: 'Code',
        dataKey: 'code',
        isFilter: false,
        isSort: true,
        tooltip: true
      },
      {
        label: 'Title',
        dataKey: 'title',
        isFilter: false,
        isSort: true,
        tooltip: true,
        lowercase: true
      },
      {
        label: 'Time Stamp',
        dataKey: 'timestamp',
        isFilter: false,
        isSort: true,
        tooltip: true,
        lowercase: true
      },
      {
        label: 'Description',
        dataKey: 'description',
        isFilter: false,
        isSort: true,
        tooltip: true,
        lowercase: false
      }
    ];
    if (playoutFeed && playoutFeed.errors) {
      Object.keys(playoutFeed.errors).map((errorCode, index) => {
        errorRows.push({
          ...playoutFeed.errors[errorCode],
          code: errorCode,
          dataKey: index,
          timestamp: playoutFeed.errors[errorCode].timestamp
            ? moment
                .unix(parseInt(playoutFeed.errors[errorCode].timestamp, 10))
                .format('YYYY-MM-DD HH:mm:ss')
            : 'NA'
        });
      });
    }
    if (
      playoutFeed &&
      playoutFeed.status === 'ERROR' &&
      errorRows.length === 0 &&
      playoutFeed.not_ended_messages.length > 0
    ) {
      errorRows = playoutFeed.not_ended_messages;
    }

    if (playoutFeed && playoutFeed.warnings) {
      Object.keys(playoutFeed.warnings).map((errorCode, index) => {
        warningRows.push({
          ...playoutFeed.warnings[errorCode],
          code: errorCode,
          dataKey: index,
          timestamp: playoutFeed.warnings[errorCode].timestamp
            ? moment
                .unix(parseInt(playoutFeed.warnings[errorCode].timestamp, 10))
                .format('YYYY-MM-DD HH:mm:ss')
            : 'NA'
        });
      });
    }
    return playoutFeed ? (
      <Grid container>
        {this.renderGridItem('Customer', playoutFeed.customer, blur)}
        {this.renderGridItem(
          'Feed Name',
          this.props.feedMap[`${playoutFeed.feed_code}#${playoutFeed.customer}`]
            .name,
          blur
        )}
        {this.renderGridItem('Headend Code', playoutFeed.headend, blur)}
        {this.renderGridItem('Headend Name', playoutFeed.name, blur)}
        {this.renderGridItem(
          'Last Checked',
          playoutFeed.last_checked
            ? moment
                .unix(parseInt(playoutFeed.last_checked, 10))
                .format('YYYY-MM-DD HH:mm:ss')
            : 'NA'
        )}
        {errorRows.length !== 0
          ? this.renderTable('Errors', errorRows, header)
          : null}
        {warningRows.length !== 0
          ? this.renderTable('Warnings', warningRows, header)
          : null}
        <Grid item xs={12}>
          <React.Fragment>
            <MyButton
              disabled={multiFeedViewUrl === ''}
              className={this.props.classes.actionButtons}
              btnType={'yellow'}
              onClick={() => window.open(multiFeedViewUrl, '_blank')}
            >
              Go to MultiFeed View
            </MyButton>

            {playoutFeed.status === 'ERROR' ||
            playoutFeed.status === 'WARNING' ? (
              <MyButton
                className={this.props.classes.actionButtons}
                btnType="yellow"
                onClick={this.props.onOpenSnoozeForm}
              >
                Snooze
              </MyButton>
            ) : null}
          </React.Fragment>
        </Grid>
      </Grid>
    ) : (
      <div />
    );
  }
}

interface IPlayoutStreamSummaryOwnProps extends WithStyles<typeof styles> {
  playoutFeed: IPlayoutScreen;
  feedMap: { [key: string]: IFeed };
  onOpenSnoozeForm: () => any;
}

export default withStyles(styles)(PlayoutStreamSummary);
